import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import  ThemeToggle  from './ThemeToggle';

const AdminLinks = () => {
  const [showAdmin, setShowAdmin] = useState(
    () => localStorage.getItem('showAdminLinks') === 'true'
  );

  useEffect(() => {
    const handleKeyDown = (e) => {
      // F9 to toggle
      if (e.key === 'F9') {
        e.preventDefault();
        setShowAdmin((prev) => {
          const next = !prev;
          localStorage.setItem('showAdminLinks', next);
          return next;
        });
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  if (!showAdmin) return null;

  return (
    <>
      <Link to="/login" className="ev-btn-blue-fill-round ev-btn-large ev-fs-12 ev-bold-reg">
        <i className="bi bi-hdd-stack"></i> &nbsp;IAM Console
      </Link>

      <Link to="/admin-login" className="ev-btn-blue-fill-round ev-btn-large ev-fs-12 ev-bold-reg">
        <i className="bi bi-hdd-stack"></i> &nbsp; Administration
      </Link>
    </>
  );
};

const GlobalNav = () => {
  return (
    <div className="row pt-3"  >
    <div className="col-3">
      <Link to="/" className="text-decoration-none"><img src="/media/bms_logo.png"   className="logo-color w-70" /></Link>
    </div>
    <div className="col-9 text-end d-flex justify-content-end align-items-center gap-3">
      <span className="ev-message-card1 ev-btn-large ev-fs-12 ev-bold-med">HTA Dossier</span>

      <AdminLinks />

      <ThemeToggle/>
    </div>
  </div>
  );
};
export default GlobalNav;
